import { Box, useTheme } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";

const currencyFormatter = (params) => `$${Number(params.value ?? 0).toFixed(2)}`;

const columns = [
  { field: "company_name", headerName: "Empresa", flex: 1, minWidth: 160 },
  { field: "country_name", headerName: "País", flex: 0.7, minWidth: 120 },
  { field: "period", headerName: "Período", flex: 0.6, minWidth: 110 },
  { field: "pickup_count", headerName: "Pickups", type: "number", flex: 0.5, minWidth: 100 },
  {
    field: "pickup_amount",
    headerName: "Monto Pickup",
    type: "number",
    flex: 0.7,
    minWidth: 130,
    valueFormatter: currencyFormatter,
  },
  { field: "delivery_count", headerName: "Deliveries", type: "number", flex: 0.5, minWidth: 100 },
  {
    field: "delivery_amount",
    headerName: "Monto Delivery",
    type: "number",
    flex: 0.7,
    minWidth: 140,
    valueFormatter: currencyFormatter,
  },
  {
    field: "total_facturado",
    headerName: "Total Facturado",
    type: "number",
    flex: 0.8,
    minWidth: 150,
    valueFormatter: currencyFormatter,
  },
  {
    field: "total_cobrado",
    headerName: "Total Cobrado",
    type: "number",
    flex: 0.8,
    minWidth: 150,
    valueFormatter: currencyFormatter,
    cellClassName: "sales-report-cobrado-cell",
  },
  {
    field: "pendiente",
    headerName: "Pendiente",
    type: "number",
    flex: 0.7,
    minWidth: 130,
    valueFormatter: currencyFormatter,
    cellClassName: "sales-report-pendiente-cell",
  },
];

const SalesTable = ({ data, onRowClick }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      sx={{
        "& .MuiDataGrid-root": { border: "none" },
        "& .MuiDataGrid-cell": { borderBottom: "none" },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: colors.blueAccent[700],
          borderBottom: "none",
          color: "white",
        },
        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: colors.primary[400],
        },
        "& .MuiDataGrid-footerContainer": {
          borderTop: "none",
          backgroundColor: colors.blueAccent[700],
        },
        "& .sales-report-cobrado-cell": {
          color: colors.greenAccent[400],
          fontWeight: "bold",
        },
        "& .sales-report-pendiente-cell": {
          color: colors.redAccent[400],
          fontWeight: "bold",
        },
      }}
    >
      <DataGrid
        autoHeight
        rows={data}
        columns={columns}
        getRowId={(row) => `${row.company_id}-${row.country_id}-${row.period}`}
        density="compact"
        slots={{ toolbar: GridToolbar }}
        initialState={{ sorting: { sortModel: [{ field: "period", sort: "desc" }] } }}
        onRowClick={(params) => onRowClick?.(params.row)}
        sx={{ "& .MuiDataGrid-row": { cursor: "pointer" } }}
      />
    </Box>
  );
};

export default SalesTable;
